import { FormControl } from '@angular/forms';

export const numericValidator = (ctrl: FormControl): { digits: boolean } | null =>
{
    ctrl.markAsTouched();

    if (/^\d+$/.test(ctrl.value))
    {
        return null;
    }

    return {
        digits: true
    };
};
